import React, { useContext } from 'react';
import {
  arrayOf, bool, shape, string, number
} from 'prop-types';
import {
  Col, Carousel, Placeholder
} from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames/bind';
import { CarouselHeader } from '../CarouselHeader';
import { CategoryTile } from './CategoryTile';
import { ArticleGuidesTile } from '../../article-guides/ArticleGuidesTile/ArticleGuidesTile';
import styles from './CategoryCarousel.module.scss';

const cx = classNames.bind(styles);

const CategoryCarousel = (props) => {
  const {
    breakpoints,
    categories,
    componentName,
    hideTextPlaceholder,
    hideTitle,
    loading,
    pageType,
    placeholderSize,
    showLoading,
    title,
    slidesPerView,
    slidesPerGroup,
    hideCarouselArrows
  } = props;
  const { channel } = useContext(ExperienceContext);
  const NUM_OF_PLACEHOLDERS = channel === 'mobile' ? 2 : 6;
  const isLoading = showLoading && loading;
  /**
   * Note: The isArticleGuide variable is responsible for
   * conditional logic that will break if the value doesn't
   * exactly match the componentName prop value from ArticleGuides.js
   */
  const isArticleGuide = componentName === 'article-guide';

  return (
    <>
      {!hideTitle && <CarouselHeader title={title} />}
      <Col>
        {isLoading && (
          <div className={cx('category-placeholders')}>
            {[...Array(NUM_OF_PLACEHOLDERS)].map((__, index) => (
              <div className="category-placeholder" key={index}>
                <Placeholder type="rect" height={placeholderSize} width={placeholderSize} />
                {!hideTextPlaceholder && <Placeholder type="text" width={placeholderSize} />}
              </div>
            ))}
          </div>
        )}
        <Carousel
          slidesPerView={slidesPerView}
          slidesPerGroup={slidesPerGroup}
          breakpoints={breakpoints}
          hideCarouselArrows={hideCarouselArrows}
        >
          {categories.map((tile) => {
            if (isArticleGuide) {
              return <ArticleGuidesTile article={tile} pageType={pageType} key={tile?.guid} />;
            }

            return <CategoryTile category={tile} componentName={componentName} key={tile?.id} />;
          })}
        </Carousel>
      </Col>
    </>
  );
};

CategoryCarousel.displayName = 'CategoryCarousel';

CategoryCarousel.propTypes = {
  breakpoints: shape({
    sm: shape(),
    md: shape(),
    lg: shape(),
    xl: shape()
  }),
  categories: arrayOf(shape()),
  componentName: string,
  hideTextPlaceholder: bool,
  hideTitle: bool,
  loading: bool,
  pageType: string,
  placeholderSize: string,
  showLoading: bool,
  title: string,
  slidesPerView: number,
  slidesPerGroup: number,
  hideCarouselArrows: bool
};

CategoryCarousel.defaultProps = {
  breakpoints: undefined,
  categories: [],
  componentName: '',
  hideTextPlaceholder: false,
  hideTitle: false,
  loading: false,
  pageType: null,
  placeholderSize: '200px',
  showLoading: false,
  title: '',
  slidesPerView: 3,
  slidesPerGroup: 3,
  hideCarouselArrows: false
};

export { CategoryCarousel };
